import React from 'react'

export default function Test() {
    return (
        <div>
            <div className="mt-4 p-5 rounded-lg shadow bg-white">
                {/* <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-md">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-semibold text-gray-800">Attendance for 11-12-1234</h2>
                    <input
                        type="date"
                        // Convert to yyyy-mm-dd for input
                        className="px-4 py-2 border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <h3 className="text-lg font-medium text-blue-600 mb-4">Classes on</h3>
                <ul className="space-y-4">
                            <li className="flex items-center justify-between">
                                <span className="text-gray-700 text-lg">ABC</span>
                                <div className="flex items-center gap-4">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                           className="text-red-500"
                                        />
                                        <span>Absent</span>
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            className="text-yellow-500"
                                        />
                                        <span>Cancel</span>
                                    </label>
                                </div>
                            </li> </ul>
            </div> */}
                <div className='flex'>
                    <div
                        role="button"
                        class={"flex mt-1 w-full items-center rounded-lg p-0 transition-all hover:bg-slate-100 focus:bg-slate-100 active:bg-slate-100 "}
                    >
                        <label
                            htmlFor={`subject-`}
                            class="peer flex w-full cursor-pointer items-center px-3 py-2"
                        >
                            <div class="inline-flex items-center">
                                <label class="flex items-center cursor-pointer relative" htmlFor={`subject-`}>
                                    <input type="checkbox"
                                        class="peer h-6 w-6 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                                        id={`subject-`} />
                                    <span class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                        {/* <svg  xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor"
                      stroke="currentColor" stroke-width="1">
                      <path fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"></path>
                    </svg> */}
                                        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 7V13M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <circle cx="12" cy="16.5" r="1" fill="#fff" />
                                        </svg>
                                        {/* <div class="w-4 h-4 rounded-full animate-spin
                    border-2 border-solid border-white border-t-transparent"></div> */}
                                    </span>
                                </label>
                                <label class="cursor-pointer ml-2 text-slate-600 text-sm" htmlFor={`subject-`}>
                                    Subject 2
                                </label>
                            </div>
                        </label>
                    </div>
                </div>
            </div>

        </div>
    )
}
